<template>
  <ThreeColumnLayout>
    <main class="home w-full flex flex-col relative">
      <img
        class="home__strip home__strip--top home__strip--viewport-sm hidden w-full"
        :src="topProduitSrc"
        alt=""
        width="768"
        height="96"
      />
      <img
        class="home__strip home__strip--top home__strip--viewport-xs hidden w-full"
        :src="topProduitXsSrc"
        alt=""
        width="360"
        height="60"
      />

      <div class="home__middle relative flex-1 flex flex-col w-full min-h-0">
        <div class="home__bg-layer" aria-hidden="true">
          <img
            class="home__bg-img home__bg-img--lg"
            :src="backgroundSrc"
            alt=""
            width="2020"
            height="2654"
          />
          <img
            class="home__bg-img home__bg-img--xl hidden"
            :src="backgroundXlSrc"
            alt=""
            width="1680"
            height="2208"
          />
          <img
            class="home__bg-img home__bg-img--md hidden"
            :src="backgroundMdSrc"
            alt=""
            width="828"
            height="1176"
          />
          <img
            class="home__bg-img home__bg-img--sm hidden"
            :src="backgroundSmSrc"
            alt=""
            width="768"
            height="1144"
          />
          <img
            class="home__bg-img home__bg-img--xssm hidden"
            :src="backgroundXsSmSrc"
            alt=""
            width="720"
            height="1561"
          />
          <img
            class="home__bg-img home__bg-img--xs hidden"
            :src="backgroundXsSrc"
            alt=""
            width="360"
            height="911"
          />
        </div>

        <div class="home__inner flex-1 flex flex-col relative z-[1] min-h-0">
          <div class="home__hero flex-shrink-0">
            <div class="home__main-wrap flex justify-center w-full">
              <img
                class="home__main block w-auto max-w-full h-auto"
                :src="mainSvgSrc"
                alt=""
                width="465"
                height="424"
              />
            </div>
            <div class="home__cta-wrap flex justify-center w-full">
              <router-link :to="{ name: 'quizz-etape-1' }" class="home__play">
                Je joue !
              </router-link>
            </div>
          </div>

          <div class="home__legal mt-auto text-center">
            <p class="home__legal-cond">
              Jeu conditionné à l'achat de 2 paquets de biscuits
            </p>
            <p class="home__legal-rules">
              <a
                class="home__legal-link"
                :href="reglementPdfUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                * Voir le
                <span class="home__legal-rules-underline">règlement</span>
              </a>
            </p>
          </div>
        </div>
      </div>

      <img
        class="home__strip home__strip--bottom home__strip--viewport-sm hidden w-full"
        :src="bottomProduitSrc"
        alt=""
        width="768"
        height="96"
      />
      <img
        class="home__strip home__strip--bottom home__strip--viewport-xs hidden w-full"
        :src="bottomProduitXsSrc"
        alt=""
        width="360"
        height="60"
      />
    </main>
  </ThreeColumnLayout>
</template>

<script>
import ThreeColumnLayout from "@/components/ThreeColumnLayout.vue";
import homeBackground from "@/assets/images/home/background.jpg";
import homeBackgroundXl from "@/assets/images/home/background-xl.jpg";
import homeBackgroundMd from "@/assets/images/home/background-md.jpg";
import homeBackgroundSm from "@/assets/images/home/background-sm.jpg";
import homeBackgroundXs from "@/assets/images/home/background-xs.jpg";
import homeBackgroundXsSm from "@/assets/images/home/background-xssm.jpg";
import topProduitSvg from "@/assets/images/home/top-produit.svg";
import bottomProduitSvg from "@/assets/images/home/bottom-produit.svg";
import topProduitXsSvg from "@/assets/images/home/top-produit-xs.svg";
import bottomProduitXsSvg from "@/assets/images/home/bottom-produit-xs.svg";
import mainSvg from "@/assets/images/home/main.svg";
import { REGLEMENT_JEU_PDF_URL } from "@/constants/reglement";
import { preloadImages } from "@/utils/preloadImages";

export default {
  name: "HomeView",
  components: {
    ThreeColumnLayout,
  },
  data() {
    return {
      backgroundSrc: homeBackground,
      backgroundXlSrc: homeBackgroundXl,
      backgroundMdSrc: homeBackgroundMd,
      backgroundSmSrc: homeBackgroundSm,
      backgroundXsSrc: homeBackgroundXs,
      backgroundXsSmSrc: homeBackgroundXsSm,
      topProduitSrc: topProduitSvg,
      bottomProduitSrc: bottomProduitSvg,
      topProduitXsSrc: topProduitXsSvg,
      bottomProduitXsSrc: bottomProduitXsSvg,
      mainSvgSrc: mainSvg,
      reglementPdfUrl: REGLEMENT_JEU_PDF_URL,
    };
  },
  mounted() {
    import("@/preloads/quizz1").then((m) => preloadImages(m.default));
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  /* La zone hero fait 1200px : le footer ne remonte pas “dans” le visuel */
  min-height: 1200px;
}

/* Rangées mobiles (768px max) · top-produit / contenu / bottom-produit */
.home__strip {
  display: none;
  flex-shrink: 0;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.home__middle {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

/* Bandeau : pleine largeur de la colonne centrale (1010px max), hauteur max 1200px */
.home__bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1200px;
  max-height: 1200px;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

/*
 * Remplir toute la largeur du centre ; object-fit: cover conserve les proportions
 * dans le rectangle largeur × 1200px (recadrage éventuel haut/bas ou côtés).
 */
.home__bg-img {
  display: block;
  width: 100%;
  height: 1200px;
  max-height: 1200px;
  object-fit: cover;
  object-position: top center;
}

/* Fond XL (≥1250px) : background-xl.jpg */
.home__bg-img--xl {
  display: none;
}

/* Fond créa tablet (828px + bandeaux) : background-md.jpg */
.home__bg-img--md {
  display: none;
}

/* Fond créa mobile (max 768) : background-sm.jpg */
.home__bg-img--sm {
  display: none;
}

/*
 * Grand écran ≥1250px : fond XL affiché, fond LG masqué.
 * On utilise aspect-ratio sur home__middle pour que la hauteur suive les
 * proportions de l'image XL (1680×2208) en fonction de la largeur du centre.
 * Le fond et le contenu restent positionnés comme d'habitude (absolu / relatif).
 */
@media (min-width: 1250px) {
  .home__bg-img--lg {
    display: none !important;
  }

  .home__bg-img--xl {
    display: block;
    height: 100%;
    max-height: none;
  }

  .home {
    min-height: 0;
  }

  .home__middle {
    aspect-ratio: 1680 / 2208;
    flex: none;
    min-height: 0;
    height: auto;
    width: 100%;
  }

  .home__bg-layer {
    height: 100%;
    max-height: none;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .home {
    min-height: 1176px;
  }

  .home__bg-layer {
    height: 1176px;
    max-height: 1176px;
  }

  .home__bg-img {
    height: 1176px;
    max-height: 1176px;
  }

  .home__bg-img--lg {
    display: none;
  }

  .home__bg-img--md {
    display: block;
  }

  .home__bg-img--sm {
    display: none;
  }
}

/* Mobile 360–767px : 3 lignes · bandeaux produits + centre background-sm.jpg */
@media (max-width: 767px) {
  .home {
    min-height: 0;
  }

  .home__strip.home__strip--viewport-sm {
    display: block;
  }

  .home__strip.home__strip--viewport-xs {
    display: none;
  }

  .home__middle {
    flex: none;
    /* Hauteur proportionnelle au fond mobile background-sm (768 × 1144) */
    aspect-ratio: 768 / 1144;
    min-height: 0;
    overflow: hidden;
  }

  .home__bg-layer {
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    width: 100%;
    height: auto;
    aspect-ratio: 768 / 1144;
    min-height: 0;
    max-height: none;
  }

  .home__bg-img--lg,
  .home__bg-img--md {
    display: none !important;
  }

  .home__bg-img {
    height: auto;
    max-height: none;
  }

  .home__bg-img--sm {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    object-position: top center;
  }
}

.home__inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  padding: 64px 1rem 0;
  min-height: 0;
}

.home__hero {
  flex-shrink: 0;
}

.home__main-wrap {
  display: flex;
  justify-content: center;
  width: 100%;
}

.home__main {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
}

/* Tablette 768–1024px : illustration max 465px (maquette 1024) */
@media (min-width: 768px) and (max-width: 1024px) {
  .home__main {
    max-width: 465px;
    width: 100%;
  }
}

.home__cta-wrap {
  margin-top: 45px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.home__play {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 400px;
  max-width: 100%;
  height: 88px;
  padding: 0 1rem;
  border: none;
  border-radius: 32px;
  background: var(--Rouge, #e30717);
  color: var(--Blanc, #fff);
  text-align: center;
  text-decoration: none;
  font-family: "Intro Demo", "Arial Black", "Helvetica Neue", sans-serif;
  font-size: 64px;
  font-style: normal;
  font-weight: 900;
  line-height: 76px;
  text-transform: uppercase;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.home__play:hover,
.home__play:focus-visible {
  filter: brightness(1.05);
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.home__legal {
  margin-top: auto;
  padding: 0.35rem 0 1.75rem;
  text-align: center;
}

.home__legal-cond {
  margin: -6px 0 45px;
  color: var(--Marron, #672e12);
  text-align: center;
  font-family: "Intro Demo", "Arial Black", "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
  text-transform: uppercase;
}

.home__legal-rules {
  margin: -25px 0 0;
  text-align: center;
}

.home__legal-link {
  color: var(--Noir, #000);
  text-align: center;
  text-decoration: none;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.home__legal-link:hover .home__legal-rules-underline,
.home__legal-link:focus-visible .home__legal-rules-underline {
  text-decoration-thickness: max(2px, 0.08em);
}

.home__legal-rules-underline {
  color: var(--Noir, #000);
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

/*
 * Mobile ≤360px : doit suivre les styles « desktop » ci-dessus (même spécificité scoped) —
 * sinon `.home__main`, `.home__play`, `.home__legal-*` réécrasent ces réglages.
 */
/* 361–550px : fond-xssm (720×1378) */
@media (max-width: 550px) {
  .home__strip.home__strip--viewport-sm {
    display: none;
  }

  .home__strip.home__strip--viewport-xs {
    display: block;
  }

  .home__bg-img--sm {
    display: none !important;
  }

  .home__bg-img--xssm {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    object-position: top center;
  }

  /* Hauteur proportionnelle au fond-xssm (720 × 1561) */
  .home__middle {
    aspect-ratio: 720 / 1561;
    min-height: 0;
  }

  .home__bg-layer {
    aspect-ratio: 720 / 1561;
  }
}

/* ≤360px : fond background-xs (360×911), remplace xssm */
@media (max-width: 360px) {
  .home__bg-img--xssm {
    display: none !important;
  }

  .home__bg-img--xs {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    object-position: top center;
  }

  /* Hauteur proportionnelle au fond xs background-xs (360 × 911) */
  .home__middle {
    aspect-ratio: 360 / 911;
    min-height: 0;
  }

  .home__bg-layer {
    aspect-ratio: 360 / 911;
  }

  .home__inner {
    flex: 1 1 0;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }

  .home__main {
    max-width: 310px;
    width: 100%;
  }

  /* CTA : Dim. 360 / Titre 1 — éviter le passage sur 2 lignes (largeur bouton − padding trop faible avec 52px) */
  .home__play {
    display: flex;
    box-sizing: border-box;
    width: min(320px, 100%);
    height: 70px;
    padding: 6px 14px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 32 / 7;
    border-radius: 32px;
    background: var(--Rouge, #e30717);
    color: var(--Blanc, #fff);
    text-align: center;
    white-space: nowrap;
    overflow: visible;
    font-family: "Intro Demo", "Arial Black", "Helvetica Neue", sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 900;
    line-height: 40px;
    text-transform: uppercase;
    letter-spacing: -0.02em;
  }

  .home__legal-cond {
    font-size: 14px;
    line-height: 18px;
    margin: -6px 0 28px;
  }

  /* Moins d’air sous le bloc légal avant le ruban puis le footer */
  .home__legal {
    padding: 0.25rem 0 0;
  }

  .home__legal-rules {
    margin: 0;
  }
}

/* ─── Overrides fluides (remplacent les valeurs fixes ci-dessus) ─────────────
 * Ces règles arrivent EN DERNIER → elles surchargent toutes les règles media
 * query précédentes pour les propriétés concernées.
 */

/*
 * Hauteur hero fluide : 1176px (768px) → 1200px (1024+).
 * Scoped à ≤1249px : au-dessus, l'image XL pilote la hauteur naturellement.
 */
@media (max-width: 1249px) {
  .home {
    min-height: clamp(
      1176px,
      calc(1176px + 24 * ((100vw - 768px) / 256)),
      1200px
    );
  }

  .home__bg-layer {
    height: clamp(1176px, calc(1176px + 24 * ((100vw - 768px) / 256)), 1200px);
    max-height: 1200px;
  }

  .home__bg-img {
    height: clamp(1176px, calc(1176px + 24 * ((100vw - 768px) / 256)), 1200px);
    max-height: 1200px;
  }
}

@media (max-width: 767px) {
  .home {
    min-height: 0;
  }

  .home__bg-layer {
    height: auto;
    max-height: none;
  }

  .home__bg-img {
    height: auto;
    max-height: none;
  }
}

/* Padding horizontal du conteneur intérieur : fluide 1rem → 2rem */
.home__inner {
  padding-left: clamp(1rem, 3vw, 2rem);
  padding-right: clamp(1rem, 3vw, 2rem);
  /* Padding top : 48px (xs) → 64px (desktop) */
  padding-top: clamp(48px, calc(38px + 2.7vw), 64px);
}

/* Illustration : fluide de 310px (360px viewport) à 465px (≥1024px) */
.home__main {
  max-width: clamp(310px, calc(207px + 28.5vw), 465px);
}

/* Marge au-dessus du CTA : 28px → 45px */
.home__cta-wrap {
  margin-top: clamp(28px, calc(14px + 3.5vw), 45px);
}

/*
 * Bouton "Je joue !" — entièrement fluide
 *   Largeur  : clamp(280px, 80vw, 400px)
 *   Hauteur  : clamp(70px,  51px + 4.7vw, 88px)
 *   Font     : clamp(48px,  35px + 3.6vw, 64px)
 */
.home__play {
  width: clamp(280px, 80vw, 400px);
  height: clamp(70px, calc(51px + 4.7vw), 88px);
  border-radius: clamp(24px, 3vw, 32px);
  font-size: clamp(48px, calc(35px + 3.6vw), 64px);
  line-height: 1.2;
  white-space: nowrap;
  padding: 0 1rem;
}

/* Texte légal : taille fluide 13px → 16px */
.home__legal-cond {
  font-size: clamp(13px, calc(11px + 0.5vw), 16px);
  line-height: 1.35;
  margin-bottom: clamp(28px, calc(14px + 3.5vw), 45px);
}
</style>
